import { ProductEventsApiClient } from '@/clients/productEventsApiClient';
import type { PageEventPayload, RecordPageEventsResult } from '@/types/productEvents';

/** FIN-1154 PE-R14: the consultant app's page events into our own event store (product_events). */
export class ProductEventsService {
  private apiClient: ProductEventsApiClient;

  constructor() {
    this.apiClient = new ProductEventsApiClient();
  }

  async sendPageEvents(events: PageEventPayload[], options: { keepalive?: boolean } = {}): Promise<RecordPageEventsResult> {
    return this.apiClient.recordPageEvents(events, options);
  }
}
